// Base exception
export {HttpException} from "./http.exception.js";

// Client errors (4xx)
export {BadRequestException} from "./bad-request.exception.js";
export {UnauthorizedException} from "./unauthorized.exception.js";
export {ForbiddenException} from "./forbidden.exception.js";
export {NotFoundException} from "./not-found.exception.js";
export {MethodNotAllowedException} from "./method-not-allowed.exception.js";
export {ConflictException} from "./conflict.exception.js";
export {UnprocessableEntityException} from "./unprocessable-entity.exception.js";

// Server errors (5xx)
export {InternalServerErrorException} from "./internal-server-error.exception.js";
export {BadGatewayException} from "./bad-gateway.exception.js";
export {ServiceUnavailableException} from "./service-unavailable.exception.js";
export {GatewayTimeoutException} from "./gateway-timeout.exception.js";
